import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as PermisoService from '../../axios_services/permisosalida.service';

const MOTIVOS = [
  { value: 'PERSONAL',     label: 'Personal' },
  { value: 'MEDICO',       label: 'Médico / Salud' },
  { value: 'COMISION',     label: 'Comisión de servicio' },
  { value: 'TRAMITES',     label: 'Trámites personales' },
  { value: 'CAPACITACION', label: 'Capacitación' },
  { value: 'OTROS',        label: 'Otros' },
];

const ModalPermisoSalida = ({ isOpen, onClose, onRefresh, currentUserId }) => {
  const today = new Date().toISOString().split('T')[0];

  const getInitial = () => ({
    fecha_salida:   today,
    fecha_regreso:  '',
    motivo:         'PERSONAL',
    motivo_detalle: '',
  });

  const [formData, setFormData] = useState(getInitial());
  const [saving,   setSaving]   = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFormData(getInitial());
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.fecha_salida) {
      alert('La Fecha de salida es obligatoria.');
      return;
    }
    if (formData.motivo === 'OTROS' && !formData.motivo_detalle.trim()) {
      alert('Especifique el detalle del motivo.');
      return;
    }
    if (!window.confirm('¿Desea registrar este permiso de salida?')) return;
    await doRegistrar();
  };

  const doRegistrar = async () => {
    setSaving(true);
    try {
      await PermisoService.insertPermiso({
        usuario_id:     currentUserId,
        fecha_salida:   formData.fecha_salida,
        fecha_regreso:  formData.fecha_regreso || null,
        motivo:         formData.motivo,
        motivo_detalle: formData.motivo === 'OTROS' ? formData.motivo_detalle : null,
      });
      onRefresh();
      onClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al registrar el permiso.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>NUEVO PERMISO DE SALIDA</h1>
          <Button className="close-btn" onClick={onClose}>X</Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form className="fila" onSubmit={e => e.preventDefault()}>

            <FormGroup style={{ gridColumn: '1 / -1' }}>
              <Label>Motivo: *</Label>
              <Input type="select" name="motivo" value={formData.motivo} onChange={handleChange}>
                {MOTIVOS.map(m => (
                  <option key={m.value} value={m.value}>{m.label}</option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label>Fecha de salida: *</Label>
              <Input
                type="date"
                name="fecha_salida"
                value={formData.fecha_salida}
                onChange={handleChange}
              />
            </FormGroup>

            <FormGroup>
              <Label>Fecha de regreso:</Label>
              <Input
                type="date"
                name="fecha_regreso"
                value={formData.fecha_regreso}
                onChange={handleChange}
                min={formData.fecha_salida}
              />
            </FormGroup>

            {formData.motivo === 'OTROS' && (
              <FormGroup style={{ gridColumn: '1 / -1' }}>
                <Label>Detalles: *</Label>
                <Input
                  type="textarea"
                  name="motivo_detalle"
                  value={formData.motivo_detalle}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Describa el motivo..."
                />
              </FormGroup>
            )}

            <FormGroup style={{ marginTop: '18px', gridColumn: '1 / -1' }}>
              <div className="button-container">
                <Button className="button-custom" onClick={handleSubmit} disabled={saving}>
                  {saving ? 'REGISTRANDO...' : 'REGISTRAR'}
                </Button>
              </div>
            </FormGroup>

          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default ModalPermisoSalida;
